// extracted by mini-css-extract-plugin
module.exports = {"container":"CollapsibleList_container__6JX4K"};